import { useAppSelector } from "common/services/reduxToolkitHooks";
import { useFormikContext } from "formik";
import { useEffect } from "react";

type Props = {};
export const FillFormWithRedux = (props: Props) => {
  const { setValues } = useFormikContext();

  const formData = useAppSelector((state) => state.public.formData);

  useEffect(() => {
    formData && setValues(formData);
  }, [formData]);
  return null;
};
